import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import IOnProcessRepGroupDTO from "../../../models/DTO/IOnProcessRepGroupDTO";
import { IProcessRepGroupDTO } from "../../../models/DTO/IProcessRepGroupDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INotification from "../../../models/INotification";
import IRepGroup from "../../../models/IRepGroup";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { SocketContext } from "../../../contexts/SocketContext";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import UiContext from "../../../contexts/UiContext";

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    repGroup?: IRepGroup;
};

export const RepGroupSidebar = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const uiContext = useContext(UiContext);

    const socket = useContext(SocketContext)!;

    const [createActive, setCreateActive] = useState(false);
    const [name, setName] = useState(props.repGroup?.name || "");
    const [email, setEmail] = useState(props.repGroup?.email || "");

    const create = () => {
        const payload: IProcessRepGroupDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            repGroup: {
                name,
                email,
            },
        };

        if (props.repGroup) {
            // @ts-expect-error
            payload.repGroup.guid = props.repGroup.guid;
        }

        socket.emit(EndpointsEnum.RepGroupProcessRepGroup, payload);

        setCreateActive(true);
    };

    const onProcessRepGroup = (data: IOnProcessRepGroupDTO) => {
        const notification: INotification = {
            message: "successfully_processed_rep_group",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        uiContext.notifyFn(null, notification);

        cancel(true);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.RepGroupOnProcessRepGroup, fn: onProcessRepGroup }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const cancel = (refreshData?: boolean) => {
        props.cancelFn(refreshData);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        switch (name) {
            case "name":
                setName(value);
                break;

            case "email":
                setEmail(value);
                break;
        }
    };

    return (
        <div className={"RepGroupSidebar p-2"}>
            <div className={"col-12"}>
                <div className="text-end">
                    <button
                        className="btn btn-danger btn-sm"
                        onClick={() => {
                            cancel();
                        }}>
                        <i className="far fa-times" />
                    </button>
                </div>
                <OwTitle className={"mb-2"} leftIconName={"fad fa-users-class"} title={"rep_group"} />
                <hr />
            </div>

            <div className={"col-12"}>
                <div>
                    <OwLabel title={"name"} />
                    <OwInputWrapper name={"name"} value={name} fn={handleChange} />
                </div>

                <div className={"mt-3"}>
                    <OwLabel title={"email"} />
                    <OwInputWrapper name={"email"} value={email} fn={handleChange} />
                </div>

                <div className={"mt-3"}>
                    <OwButton title={"save"} fn={create} active={createActive} disableOnActive={true} />
                </div>
            </div>
        </div>
    );
};
